var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from "react";
import { RangeBoundary, RangeInput, RangeSelectorContainer, RangeValue, RangeWrap } from "./styled/range-slider";
import { stripNumber } from "@wrstudios/utils";
var RangeSlider = function (_a) {
    var min = _a.min, max = _a.max, minLabel = _a.minLabel, maxLabel = _a.maxLabel, value = _a.value, onChange = _a.onChange, props = __rest(_a, ["min", "max", "minLabel", "maxLabel", "value", "onChange"]);
    var _b = useState(50), percentage = _b[0], setPercentage = _b[1];
    var _c = useState(0), adjustment = _c[0], setAdjustment = _c[1];
    useEffect(function () {
        setPercentage(Math.floor(((stripNumber(value) - stripNumber(min)) * 100) /
            (stripNumber(max) - stripNumber(min))));
        setAdjustment(8 - percentage * 0.17); // to adjust tooltip's position at center. This is calculated based on how far left or right the tooltip has moved out of place.
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RangeSelectorContainer, null,
            React.createElement(RangeBoundary, { className: "min__label" }, minLabel ? minLabel : min),
            React.createElement(RangeWrap, null,
                React.createElement(RangeValue, { style: { left: "calc(" + percentage + "% + (" + adjustment + "px))" } },
                    React.createElement("span", { className: "tooltipBox" }, value)),
                React.createElement(RangeInput, __assign({ type: "range", min: stripNumber(min), max: stripNumber(max), value: stripNumber(value), onChange: onChange }, props))),
            React.createElement(RangeBoundary, { className: "max__label" }, maxLabel ? maxLabel : max))));
};
export default RangeSlider;
